import {RsnIconWidget, Skeleton, asREM} from '@raison/ui-kit';
import React from 'react';
import {BoundaryFallbackDefault, FallbackComponent} from '~/entities/fallbacks/ui/SuspenseAndErrorBoundary';
import ListLayout from '~/shared/layouts/ListLayout/ListLayout';
import {HomeDashboardLayout, HomeLinksLayout, HomePageLayout} from './components/layouts';

export const HomePageLoadingScreen: FallbackComponent = props => {
    return (
        <BoundaryFallbackDefault {...props}>
            <HomePageLayout noRefresh>
                <HomeDashboardLayout>
                    <div></div>
                    <Skeleton height={asREM(80)} style={{gridColumn: 'span 2'}} borderRadius={asREM(16)} />
                    <Skeleton height={asREM(112)} style={{gridColumn: 'span 2'}} borderRadius={asREM(16)} />
                    <Skeleton borderRadius={asREM(16)} height={asREM(64)} />
                </HomeDashboardLayout>

                <HomeLinksLayout>
                    <RsnIconWidget.Lg
                        className={'p-4'}
                        icon={{element: <Skeleton circle height='100%' />}}
                        addon={<ListLayout.Arrow />}
                    >
                        <RsnIconWidget.TextBlock heading={<Skeleton width={80} />} details={<Skeleton width={160} />} />
                    </RsnIconWidget.Lg>
                    <RsnIconWidget.Lg
                        className={'p-4'}
                        icon={{element: <Skeleton circle height='100%' />}}
                        addon={<ListLayout.Arrow />}
                    >
                        <RsnIconWidget.TextBlock heading={<Skeleton width={80} />} details={<Skeleton width={160} />} />
                    </RsnIconWidget.Lg>
                    <RsnIconWidget.Lg
                        className={'p-4'}
                        icon={{element: <Skeleton circle height='100%' />}}
                        addon={<ListLayout.Arrow />}
                    >
                        <RsnIconWidget.TextBlock heading={<Skeleton width={80} />} details={<Skeleton width={160} />} />
                    </RsnIconWidget.Lg>
                    <RsnIconWidget.Lg
                        className={'p-4'}
                        icon={{element: <Skeleton circle height='100%' />}}
                        addon={<ListLayout.Arrow />}
                    >
                        <RsnIconWidget.TextBlock heading={<Skeleton width={80} />} details={<Skeleton width={160} />} />
                    </RsnIconWidget.Lg>
                </HomeLinksLayout>
            </HomePageLayout>
        </BoundaryFallbackDefault>
    );
};
